

class EdutechsCloudServer {

    serverRootDomain: string;

    constructor(){
        // ====== IMPORTANT NEEDS THE SLASH AT THE END OF THIS URL ============ //
        //this.serverRootDomain = "http://localhost:8383/";
        this.serverRootDomain = "https://edtch.pw/";  //FOR DEPLOY --

        //fail-safe that in live environment localhost servers will never be used..
        if (typeof window !== 'undefined' && window.location.href.includes('edutechs.app')){
            this.serverRootDomain = "https://edtch.pw/";
        }
    } 

    getServerAddress(){
        let x = this.serverRootDomain.substring(0, this.serverRootDomain.length - 1);
        return x;
    }


    async postRequestPromise(url: string, data: any, useLocalHost: boolean) {

        //check to see if the first character in url is '/' and strip it if it is
        if (url.charAt(0) === '/') {
            url = url.substring(1);
        }
        
        const fullAPI_URL = (useLocalHost === true ? 'http://localhost:8383/' : this.serverRootDomain) + url;

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }

        console.log('Calling EDUTECH CLOUD SERVER REST API POST URL ENDPOINT: ', fullAPI_URL, options);

        return fetch(fullAPI_URL, options)
            .then(response => response.json())
            .catch(error => {
                console.log(error);
            });
    }

    isWorkingProperlyAndIsUp(callback: (res: any) => void){

        const fullAPI_URL   = this.serverRootDomain + 'api-sessions/test';
        let data            = {};

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }

        fetch(fullAPI_URL, options)
            .then(data => data.json())
            .then(res => callback(res))
            .catch(e => callback(e));


    }
}

export default new EdutechsCloudServer()


